import { useDomainConfig } from 'context/DomainConfigProvider/DomainConfigProvider';
import { getStringWithoutLeadingSlash } from 'helpers/parsing/stringWithoutSlash';
import useTranslation from 'next-translate/useTranslation';
import Head from 'next/head';
import { useMemo } from 'react';
import { BreadcrumbItemType } from 'types/breadcrumb';

type BreadcrumbsMetadataProps = {
    breadcrumbs: BreadcrumbItemType[];
};

export const BreadcrumbsMetadata: FC<BreadcrumbsMetadataProps> = ({ breadcrumbs }) => {
    const { url } = useDomainConfig();
    const { t } = useTranslation();

    const breadcrumbItems: BreadcrumbItemType[] = useMemo(
        () => [{ name: t('Home page'), slug: '/' }, ...breadcrumbs],
        [breadcrumbs, t],
    );

    return (
        <Head>
            <script
                key="breadcrumbs-metadata"
                id="breadcrumbs-metadata"
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify([
                        {
                            '@context': 'https://schema.org',
                            '@type': 'BreadcrumbList',
                            itemListElement: breadcrumbItems.map((breadcrumb, index) => {
                                const breadcrumbAbsoluteUrl = url + getStringWithoutLeadingSlash(breadcrumb.slug);

                                return {
                                    '@type': 'ListItem',
                                    position: index + 1,
                                    name: breadcrumb.name,
                                    item: index === breadcrumbItems.length - 1 ? undefined : breadcrumbAbsoluteUrl,
                                };
                            }),
                        },
                    ]),
                }}
            />
        </Head>
    );
};
